import { CURRENCY } from '../../__queries__/globalTypes';

const DEFAULT_CURRENCY = CURRENCY.SEK;

export const prettify = (value: string) => {
  let text = value.replace(' ', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  if (text.substring(text.length - 3) == '.00') {
    text = text.slice(0, -3);
  }
  return text;
};

export const currencyToLocaleMap: Record<CURRENCY, string> = {
  [CURRENCY.DKK]: 'da-DK',
  [CURRENCY.EUR]: 'nl-NL',
  [CURRENCY.NOK]: 'nb-NO',
  [CURRENCY.USD]: 'en-US',
  [CURRENCY.SEK]: 'sv-SE',
  [CURRENCY.GBP]: 'en-GB',
  TRY: 'tr-TR',
  AED: 'ar-AE',
};

export const currencyToSymbol: Record<CURRENCY, string> = {
  [CURRENCY.DKK]: 'kr',
  [CURRENCY.EUR]: '€',
  [CURRENCY.NOK]: 'kr',
  [CURRENCY.USD]: '$',
  [CURRENCY.SEK]: 'kr',
  [CURRENCY.GBP]: '£',
  TRY: '₺',
  AED: 'د.إ',
};

export const formatAmount = (
  amount: number,
  currencyType: keyof typeof CURRENCY = DEFAULT_CURRENCY,
) => {
  // Guard, if the currency type is misstyped/is not supported
  if (!CURRENCY[currencyType]) {
    return (amount / 100).toString();
  }
  const locale = currencyToLocaleMap[currencyType] || currencyToLocaleMap[DEFAULT_CURRENCY];
  const showTwoDecimals = currencyType === CURRENCY.GBP || currencyType === CURRENCY.EUR;

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: CURRENCY[currencyType],
    minimumFractionDigits: showTwoDecimals ? 2 : 0,
    maximumFractionDigits: 3,
  });

  return formatter.format(amount / 100);
};

export const getCurrencySymbol = (currencyType: keyof typeof CURRENCY = DEFAULT_CURRENCY) => {
  return currencyToSymbol[currencyType];
};
